import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { SocialLoginService, Provider } from 'ngx-social-login';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/shared-service/services/user.service';
import { QuizService } from 'src/app/shared-service/services/quiz.service';
import { AppConfig } from 'src/app/app.config';
import * as moment from 'moment';
declare var $:any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  customLoginTabs = [{'tab_id': "1",
  'cat_name': "Create Account"},{'tab_id': "2",
  'cat_name': "Login"}]

  userData:any;
  keyword = 'name';
  public data = '';
  datepickerConfirg: Partial<BsDatepickerModule>;
  minDate: Date;
  maxDate: Date;
  isloader:boolean = false;
  auth2: any;
  loginForm: FormGroup;
  submitted = false;
  selectedLoginIndex=0;
  regBtn:boolean = true;
  message:any;
  isMsg:boolean = true;
  affilite_url:any;
  categoryData:any;
  menuData:any;
  registerForm: FormGroup;
  utm_source:string = '';
  utm_medium:string = '';
  utm_campaign:string = '';
  utm_term:string = '';
  package_id:any;
  is_buy: number = 0;
  toggleMenuIcon = true;
  baseUrl = '';
  rootUrl = '';
  linkToAllow = '';
  playstoreLink = '';
  phoneNo =  '';
  address =  '';
  emailId = '';
  isdCode = '';
  domain = '';
  titleName = '';
  imgWidth = '';
  imgHeight = '';
  extraMenuItems = '';
  socialLogin='';
  isJeeWebsite=1;
  isGovtWebsite=1;
  logo='';
  logo1='';

  plans={};
  purchasedPlanIds=[];


  toggleSidePanel=false;
  leftPanelTitle='';

  isTests=false;
  isQuizes=false;

  seriesData =[];
  selectedTestSeriesTab = 0;
  showTestSeries = false;
  filteredTestSeries = [];

  liveTests = [];
  livefilteredTestSeries = [];
  upcomingTests = [];
  upcomingfilteredTestSeries = [];

  isLoggedin:boolean = false;
  isRightSideToggleEnabled=0;
  urlToRestrictSidePanel=[];

  cities=[];
  states=[];
  zones=[];
  isZoneEnabled='';
  state_city='';
  interest='';

  verifyuserBtn=false;
  verify_message='';
  error_message='';
  isverified=false;
  isNumValid = false;
  mobile='';
    otp='';
  getOTPclicked =false;
  is_old_purchased=0;
  otpFetched = false;

      public dateNow = new Date();
      public dDay = new Date();
      milliSecondsInASecond = 1000;
      hoursInADay = 24;
      minutesInAnHour = 60;
      SecondsInAMinute  = 60;

      public timeDifference;
      public secondsToDday;
      public minutesToDday;
      public hoursToDday;
      public daysToDday;

      stopTimer=false;
      isFirstTime=true;

      isOTPVerified = true;
      isOtpEnabled = 0;

      whatsappNo='';
      phoneNo_1 = '';
      whatsappNo_1='';
      copyRightYear = '';
      facebookUrl = '';
      linkedInUrl = '';
      youtubeUrl = '';
      twitterUrl = '';
      instagramUrl = '';
      telegramUrl = '';
      footerDescription = '';

  whatsappCountryIsd='';
  paddingLeft=0;


  toggleNotificationsSidePanel= false;
  notificationList=[];
  menuLevelData=[];
  menuChildMap = {};
  childMenuData=[];

      isEmailLoginClicked = false;
      mobileForm: FormGroup;
      logBtn=true;
      isMobileLogin=0;
  isEmailLogin = 1;
  mainbaseurl='';
  apiUrl='';
  
  @ViewChild('googleRef', {static: true }) googleElement: ElementRef;

  constructor(
    private router:Router,
    private userService:UserService,
    private formBuilder: FormBuilder,
    // // private service: SocialLoginService,
    private route: ActivatedRoute,
    private quizService:QuizService,
    private config: AppConfig
  ) {
    this.baseUrl = this.config.getConfig('BASEURL');
    this.apiUrl = this.config.getConfig('API_URL');
    this.rootUrl = this.config.getConfig('ROOT_URL');
    this.linkToAllow = this.config.getConfig('MODULES_TO_ALLOW_BEFORE_LOGIN');
    this.playstoreLink =  this.config.getConfig('MOBILE_PLAYSTORE_URL');
    this.phoneNo =  this.config.getConfig('PHONE_NO');
    this.address =  this.config.getConfig('ADDRESS');
    this.emailId =  this.config.getConfig('EMAIL_ID');
    this.isdCode = this.config.getConfig('PHONE_ISD_CODE');
    this.domain = this.config.getConfig('DOMAIN');
    this.titleName =this.config.getConfig('TITLE');
    this.imgWidth = this.config.getConfig('LOGO_WIDTH');
    this.imgHeight = this.config.getConfig('LOGO_HEIGHT');
    this.extraMenuItems = this.config.getConfig('EXTRA_MENU_ITEMS_BEFORE_LOGIN');
    this.socialLogin = this.config.getConfig('SOCIAL_LOGIN_AND_REGISTER');
    this.isJeeWebsite = this.config.getConfig('IS_JEE_WEBSITE');
    this.isGovtWebsite = this.config.getConfig('IS_GOVT_WEBSITE');
    this.logo = this.config.getConfig('LOGO');
    this.logo1 =  this.config.getConfig('LOGO1');
    this.isZoneEnabled = this.config.getConfig('IS_ZONE_ENABLED');
    this.state_city = this.config.getConfig('STATE_CITY_ENABLED');
    this.interest = this.config.getConfig('INTEREST_ENABLED');
    this.isOtpEnabled = this.config.getConfig('IS_MOBILE_OTP_REQUIRED');
    this.isRightSideToggleEnabled = this.config.getConfig('IS_RIGHT_SIDE_PANEL_ENABLED_BEFORE_LOGIN');
    this.urlToRestrictSidePanel = this.config.getConfig('RIGHT_SIDE_PANEL_RESTRICTED_URLS');
    if(this.urlToRestrictSidePanel && this.urlToRestrictSidePanel.length > 0 && this.urlToRestrictSidePanel.indexOf(window.location.pathname) != -1) {
      this.isRightSideToggleEnabled=0;
    };

    this.linkToAllow = this.config.getConfig('MODULES_TO_ALLOW_BEFORE_LOGIN');
    this.playstoreLink =  this.config.getConfig('MOBILE_PLAYSTORE_URL');
    this.phoneNo =  this.config.getConfig('PHONE_NO');
    this.whatsappNo = this.config.getConfig('WHATSAPP_NO');
    this.phoneNo_1 =  this.config.getConfig('PHONE_NO_1');
    this.whatsappNo_1 = this.config.getConfig('WHATSAPP_NO_1');
    this.address =  this.config.getConfig('ADDRESS');
    this.emailId =  this.config.getConfig('EMAIL_ID');
    this.isdCode = this.config.getConfig('PHONE_ISD_CODE');
    this.domain = this.config.getConfig('DOMAIN');
    this.copyRightYear = this.config.getConfig('COPY_RIGHT_YEAR');
    this.facebookUrl = this.config.getConfig('FACEBOOK_LINK');
    this.linkedInUrl = this.config.getConfig('LINKEDIN_LINK');
    this.youtubeUrl = this.config.getConfig('YOUTUBE_LINK');
    this.twitterUrl = this.config.getConfig('TWITTER_LINK');
    this.instagramUrl =  this.config.getConfig('INSTAGRAM_LINK');
    this.telegramUrl = this.config.getConfig('TELEGRAM_LINK');
    this.footerDescription = this.config.getConfig('FOOTER_DESCRIPTION');
    this.imgWidth = this.config.getConfig('LOGO_WIDTH');
    this.imgHeight = this.config.getConfig('LOGO_HEIGHT');
    this.logo = this.config.getConfig('LOGO');
    this.isOtpEnabled = this.config.getConfig('IS_MOBILE_OTP_REQUIRED');
    this.isMobileLogin = this.config.getConfig('IS_OTP_LOGIN_ENABLED');
    this.isEmailLogin = this.config.getConfig('IS_EMAIL_LOGIN_ENABLED');
    this.whatsappCountryIsd = this.isdCode.replace(/\+/g,'');
    this.mainbaseurl = this.config.getConfig('MAIN_BASE_URL');
    this.paddingLeft = parseInt(this.imgWidth) + 40

    this.datepickerConfirg = Object.assign({},
      {
        containerClass: 'theme-red',
        dateInputFormat: 'DD-MM-YYYY',
        week:false
      });
  }

  ngOnInit() {
      this.route.queryParamMap.subscribe(queryParams => {
      this.utm_source = queryParams.get("utm_source");
      this.utm_medium = queryParams.get("utm_medium");
      this.utm_campaign = queryParams.get("utm_campaign");
      this.utm_term = queryParams.get("utm_term");
    });

    if(this.utm_source != null){
      var utm_data = {
        'utm_source':this.utm_source,
        'utm_medium':this.utm_medium,
        'utm_campaign':this.utm_campaign,
        'utm_term':this.utm_term
      };
      localStorage.setItem('utmData', JSON.stringify(utm_data));
    }
    if(localStorage.getItem('userData')){
      this.isLoggedin = true;
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.getPlans();
      this.router.navigate(['/user/home']);
    }

    this.getMenus();
    this.getCategories();
    // this.getMenuLevelData();
    // this.getSearch();
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.mobileForm = this.formBuilder.group({
      mobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
    });

    if(this.isOtpEnabled) {
      this.mobileForm.addControl('otp',this.formBuilder.control('', [Validators.required]));
    }
    if(!this.isOtpEnabled) {
      this.logBtn = false;
    }

   
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });

    this.registerForm = this.formBuilder.group({
      name: [''],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)] ],
      password: ['', [Validators.required, Validators.minLength(6)]],
      affilite_url: [''],
      utm_source: [this.utm_source],
      utm_medium: [this.utm_medium],
      utm_campaign: [this.utm_campaign],
      utm_term: [this.utm_term],
    });
    if(this.isZoneEnabled) {
      // this.getZoneWiseData();
      this.registerForm.addControl('customer_zone',this.formBuilder.control('', [Validators.required]));
    }
    if(this.state_city) {
      // this.getStates();
      this.registerForm.addControl('state_id',this.formBuilder.control('', [Validators.required]));
      this.registerForm.addControl('city_id',this.formBuilder.control('', [Validators.required]));
    }
    if(this.interest) {
      this.registerForm.addControl('course_interested',this.formBuilder.control('', [Validators.required]));
    }
    if(this.isOtpEnabled) {
      this.registerForm.addControl('otp',this.formBuilder.control('', [Validators.required]));
    }
    if(!this.isOtpEnabled) {
      this.regBtn = false;
    }

    if(localStorage.getItem('affiliate_code')){
      this.affilite_url = localStorage.getItem('affiliate_code');
    }


    
  }
  fetchStates() {
    if(this.states && this.states.length == 0) {
      this.getStates();
    }
  }

  fetchZones() {
    if(this.zones && this.zones.length == 0) {
      this.getZoneWiseData();
    }
  }

  get g() { return this.mobileForm.controls; }

  get k() { return this.loginForm.controls; }

  getMenuLevelData() {
    this.quizService.getMenuLevelData().subscribe((res:any) => {
      this.menuLevelData = res.data;
      this.menuLevelData.forEach(menuItem => {
        this.menuChildMap[menuItem.id] = menuItem.main_category;
      })
      if(this.menuLevelData && this.menuLevelData.length) {
        this.childMenuData = this.menuLevelData[0].main_category;
      }
      
    })
  }

  mouseEnter(id) {
    // for(var key in this.childMenuData) {
    //   $('#'+key)[0].classList.add('hide-custom-menu');
    // }
    this.childMenuData = this.menuChildMap[id];
    Object.entries(this.menuChildMap).forEach(([key, value]) => {
        console.log(`${key}: ${value}`)
        $('#'+`${key}`)[0].classList.add('hide-custom-menu');
    });


    $('#'+id)[0].classList.remove('hide-custom-menu');
    $('#'+id)[0].classList.add('show-custom-menu');
  }

  mouseLeave(div : string){
    // $('#'+div)[0].classList.remove('show-custom-menu');
    // $('#'+div)[0].classList.add('hide-custom-menu');
  }

  redirect(uri:string){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([uri]));
  }

  userLogout(){
    localStorage.clear();
    this.quizService.userlogout(this.userData.user_id).subscribe(
      (res:any) => {
        localStorage.clear();
        window.location.href = this.mainbaseurl + '/logout';
        // this.router.navigate(['/sign-in']);
      }
    );
  }

  selectEvent(item) {
    this.redirect('all-test/'+item.pid);
  }

  getSearch(){
    this.userService.searchData().subscribe(
      (res:any) =>{
        if(res.state === 200){
          this.data = res.data;
        }else{
        }
        this.isloader = true;
      }
    );
  }

  getPlans(){
    this.quizService.getPlansDataCatWise(this.userData['user_id']).subscribe(
      (res:any) => {
        if(res.state === 200){
          this.plans = res.data;
          localStorage.setItem('cps', JSON.stringify(this.plans))
          for(var item in this.plans) {
            if(item == 'all') {
              this.plans[item].forEach(pk => {
                if(pk.is_buy == 1 && pk.is_expire == 0 && pk.days_left > 0) {
                  this.purchasedPlanIds = [...this.purchasedPlanIds, ...pk.packages.split(',')];
                }
              })
            }
          };
        } else {
          if(localStorage.getItem('cps')) {
            this.plans = JSON.parse(localStorage.getItem('cps'));
            for(var item in this.plans) {
              if(item == 'all') {
                this.plans[item].forEach(pk => {
                  if(pk.is_buy == 1 && pk.is_expire == 0 && pk.days_left > 0) {
                    this.purchasedPlanIds = [...this.purchasedPlanIds, ...pk.packages.split(',')];
                  }
                })
              }
            };
          }
        }
      }, (error:any) => {
        if(localStorage.getItem('cps')) {
          this.plans = JSON.parse(localStorage.getItem('cps'));
          for(var item in this.plans) {
            if(item == 'all') {
              this.plans[item].forEach(pk => {
                if(pk.is_buy == 1 && pk.is_expire == 0 && pk.days_left > 0) {
                  this.purchasedPlanIds = [...this.purchasedPlanIds, ...pk.packages.split(',')];
                }
              })
            }
          };
        }
      }
    );
  }

  get f() { return this.registerForm.controls; }

  getZoneWiseData() {
    this.quizService.getZoneWiseData().subscribe((res:any) => {
      if(res && res.state == 200) {
        this.zones = res.data;
      }
    })
  }


  getStates() {
    this.userService.getStates().subscribe(
      (res:any) =>
      {
        if(res && res.data)
        this.states = res.data
      }
    );
  }

  onChangeState(stateId: number) {
    this.cities =[];
    this.states.forEach(state=> {
      if(state.id == stateId) {
        this.cities =state.city;
      }
    });
    this.registerForm.get('city_id').setValue('');
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    } else {
      this.regBtn = true;
      $('#regg_btn').html('please wait...');

      if(localStorage.getItem('utmData')){
        let utmData = JSON.parse(localStorage.getItem('utmData'));
        this.utm_source = utmData.utm_source;
        this.utm_medium = utmData.utm_medium;
        this.utm_campaign = utmData.utm_campaign;
        this.utm_term = utmData.utm_term;
      }
      this.registerForm.get('utm_source').setValue(this.utm_source);
      this.registerForm.get('utm_medium').setValue(this.utm_medium);
      this.registerForm.get('utm_campaign').setValue(this.utm_campaign);
      this.registerForm.get('utm_term').setValue(this.utm_term);
      if(this.registerForm.value['name'] == '') {
        this.registerForm.value['name'] = 'Guest User';
      }
      this.userService.saveRegistration(this.registerForm.value)
        .subscribe((response: any) => {
          if (response.state === 200) {
            this.message = '<div class="alert alert-success">Registered Successfully.</div>';
            localStorage.setItem('userData', JSON.stringify(response.data));
            let scholorTestId = localStorage.getItem('scholorTestId');
            if(scholorTestId) {
              this.registerClicked(response.data.user_id, scholorTestId, true);
            }else {
              this.loginSuccess();
            }
            this.regBtn=false;
          } else {
            this.message = '<div class="alert alert-danger">'+response.msg+'</div>';
            this.regBtn = false;
            this.getOTPclicked = false;
            this.otpFetched=false;
          }
          $('#regg_btn').html('Create Account');
          this.isMsg = false;
      });
    }
  }

  fbLibrary() {

    (window as any).fbAsyncInit = function () {
      window['FB'].init({
        appId: '458895534798583',
        cookie: true,
        xfbml: true,
        version: 'v3.1'
      });
      window['FB'].AppEvents.logPageView();
    };
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  login() {
    window['FB'].login((response) => {
      if (response.authResponse) {
        window['FB'].api('/me', {
          fields: 'last_name, first_name, email'
        }, (userInfo) => {
          let userData = {
            'first_name': userInfo.first_name,
            'last_name': userInfo.last_name,
            'email': userInfo.email,
            'token_id': userInfo.id,
            'reg_type': 'facebook',
            'utm_source': this.utm_source,
            'utm_medium': this.utm_medium,
            'utm_campaign': this.utm_campaign,
            'utm_term': this.utm_term,
            'affilite_url': this.affilite_url
          };
          this.userService.userRegistration(userData).subscribe(
            (res:any) =>{
              if(res.state === 200){
                localStorage.setItem('userData', JSON.stringify(res.data));
                let scholorTestId = localStorage.getItem('scholorTestId');
                if(scholorTestId) {
                  this.registerClicked(res.data.user_id, scholorTestId, true);
                }else {
                  this.loginSuccess();
                }
              }
            }
          );
        });

      }
    }, { scope: 'email' });
  }

  closeModel(){
    $('#unlock_course').modal('hide');
  }

  loginWithGoogle(): void {
    // this.service.login(Provider.GOOGLE).subscribe(
    //   profile => {
    //     let userData = {
    //       'first_name': profile.name,
    //       'email': profile.email,
    //       'profile_pic': profile.profileImg,
    //       'token_id': profile.idToken,
    //       'reg_type': 'google',
    //       'utm_source': this.utm_source,
    //       'utm_medium': this.utm_medium,
    //       'utm_campaign': this.utm_campaign,
    //       'utm_term': this.utm_term,
    //       'affilite_url': this.affilite_url
    //     };
    //     this.userService.userRegistration(userData).subscribe(
    //       (res:any) =>{
    //         if(res.state === 200){
    //           localStorage.setItem('userData', JSON.stringify(res.data));
    //           let scholorTestId = localStorage.getItem('scholorTestId');
    //           if(scholorTestId) {
    //             this.registerClicked(res.data.user_id, scholorTestId, true);
    //           }else {
    //             this.loginSuccess();
    //           }
    //         }
    //       }
    //     );
    //   }
    // );
  }

  registerClicked(userId, testId, isRegistered) {
    this.quizService.scholorIsRegisterd(userId, testId, isRegistered).subscribe((res:any) => {
      localStorage.removeItem('scholorTestId');
      this.loginSuccess();
    },
    (error:Error) => {
      this.loginSuccess();
    });
  }

  loginSuccess() {
    // $('#unlock_course').modal('hide');
    // $('#subscribe_course').modal('hide');
    // $('#unlock_course_offer').modal('hide');
    if(localStorage.getItem('currUrl')){
      window.location.href = this.config.getConfig('ROOT_URL') +JSON.parse(localStorage.getItem('currUrl'));
     // window.location.href = this.quizService.rootUrl +JSON.parse(localStorage.getItem('currUrl'));
    }else{
      this.router.navigate(['/user/home']);
    //  window.location.reload();
    }
  }

  getCategories(){
    this.quizService.getCategories().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.categoryData = res.data;
          this.categoryData = this.quizService.filterPackageData(this.config.getConfig('CATEGORIES_TO_FILTER'), this.categoryData, 'cat_id');
          this.userService.setCategoyData(res.data);
        }
      }
    );
  }

  getMenus(){
    this.quizService.getMenus().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.menuData = res.data;
        }
      }
    );
  }

  numberOnly(event): boolean {
    this.getOTPclicked = false;
    this.otpFetched = false;
    this.secondsToDday =0;
    this.minutesToDday = 0;
    this.hoursToDday = 0;
    this.daysToDday = 0;
    this.isFirstTime = true;
    if(isNaN(event.key)) {
      return false;
    }
    if(this.registerForm.value['mobile'] && this.registerForm.value['mobile'].length >= 10) {
      return false;
    }
    // if((this.registerForm.value['mobile'] == null || this.registerForm.value['mobile'] == '')) {
    //   return false;
    // }
    const charCode = (event.which) ? event.which : event.keyCode;
    if (!((charCode >= 48 && charCode  <= 57) || (charCode >= 96 && charCode <= 105))) {
      return false;
    }
    return true;
  }


  numberLoginOnly(event): boolean {
    this.getOTPclicked = false;
    this.otpFetched = false;
    this.secondsToDday =0;
    this.minutesToDday = 0;
    this.hoursToDday = 0;
    this.daysToDday = 0;
    this.isFirstTime = true;
    if(isNaN(event.key)) {
      return false;
    }
    const charCode = (event.which) ? event.which : event.keyCode;
    if (!((charCode >= 48 && charCode  <= 57) || (charCode >= 96 && charCode <= 105))) {
      return false;
    }
    return true;
  }
  

  textOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }

  openNav() {
    this.toggleMenuIcon = !this.toggleMenuIcon;
  }

  closeNav() {
    this.toggleMenuIcon = !this.toggleMenuIcon;
  }

  getAllSeriesNew(type, cat_id){
    this.quizService.getHomeSeriesDataNew(type, cat_id).subscribe(
      (res:any) =>{
        if(res.state === 200){

          let totData = [];
          for(let i=0; i<res.data.length; i++){
            //if(res.data[i].total_question != 0 && !this.userSeries.includes(res.data[i].series_id)){
            if(res.data[i].total_question != 0){
              totData.push(res.data[i]);
            }
          }
          this.seriesData = totData;
          totData = this.quizService.filterPackageData(this.config.getConfig('CATEGORIES_TO_FILTER'), totData, 'package_cat');
          this.seriesData = this.quizService.filterPackageData(this.config.getConfig('CATEGORIES_TO_FILTER'), this.seriesData, 'package_cat');
          if(totData) {
            totData.forEach(item => {
              if(new Date(item.current_date) <= new Date(item.live_to_date)) {
                this.filteredTestSeries.push(item);
              }
            });

            var onCatMap = {};
            totData.forEach(item => {
              if(new Date(item.current_date) >= new Date(item.live_from_date) && new Date(item.current_date) <= new Date(item.live_to_date)) {
                this.liveTests.push(item);
                onCatMap[item.package_cat] = {'cat_id': item.package_cat,
                'cat_name': item.category,
                'cat_slug': item.category,
                'priority': "0"};
              }
            });
            // for(var key in onCatMap) {
            //   this.ongoingCategoryData.push(onCatMap[key]);
            // }
            this.livefilteredTestSeries = this.liveTests;

            var upCatMap = {};
            totData.forEach(item => {
              if(new Date(item.current_date) < new Date(item.live_from_date)) {
                this.upcomingTests.push(item);
                upCatMap[item.package_cat] = {'cat_id': item.package_cat,
                'cat_name': item.category,
                'cat_slug': item.category,
                'priority': "0"};
              }
            });
            // for(var key in upCatMap) {
            //   this.upcomingCategoryData.push(upCatMap[key]);
            // }
            this.upcomingfilteredTestSeries = this.upcomingTests;
          }
          // this.removeOngoingEmptyTabs();
          // this.removeUpcomingEmptyTabs();
          this.seriesData = this.filteredTestSeries;
          this.isloader = true;
        } else {
          this.isloader = true;
        }
      }
    );
  }

  formatAMPMTime(dateTime) {
    var date = new Date(dateTime);
    var hours = date.getHours();
    var minutes = date.getMinutes()+'';
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10+'' ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  formatAMPMDay(dateTime) {
    let day = moment(new Date(dateTime)).format('DD-MM-YYYY');
    return day;
  }

  getTimeRangeHours(startDate, endDate, currdate) {
    var start = new Date(startDate);
    var end = new Date(endDate);
    var cur = new Date(currdate);
    if(cur > start) {
      const diffTime = Math.abs(cur.valueOf() - end.valueOf());
      const diffHours = Math.ceil(diffTime / (1000*60*60));
      return diffHours+' hrs';
    } else {
      const diffTime = Math.abs(start.valueOf() - end.valueOf());
      const diffHours = Math.ceil(diffTime / (1000*60*60));
      return diffHours+' hrs';
    }


  }

  validateDates(currData, compDate, opt){
    if(opt == "<=") {
      return new Date(currData) <= new Date(compDate);
    }
    if(opt == ">=") {
      return new Date(currData) >= new Date(compDate);
    }
  }

  setCurrUrl(cuurent_url, testId){
    this.toggleSidePanel = false;
    var ele = document.getElementById('short-cut-panel');
    ele.style['right']='0';

    var elePanel = document.getElementById('short-cut-inner-panel');
    elePanel.style['display']='none';

    localStorage.setItem('testInit', '1');
    localStorage.setItem('scholorTestId', testId);
    localStorage.setItem('currUrl',JSON.stringify(cuurent_url));
  }

  closeSideBar() {
    this.toggleSidePanel = false;
    var ele = document.getElementById('short-cut-panel');
    ele.style['right']='0';

    var elePanel = document.getElementById('short-cut-inner-panel');
    elePanel.style['display']='none';
  }

  testSideBarClick(panelName) {
    this.getAllSeriesNew('scholarship', 0);
    this.leftPanelTitle = panelName;
    if(panelName == 'Live Tests') {
      this.isTests = true;
      this.isQuizes = false;
    } else if(panelName == 'Live Quizes') {
      this.isTests = false;
      this.isQuizes = true;
    }
    this.toggleSidePanel = true;
    var ele = document.getElementById('short-cut-panel');
    ele.style['right']='350px';
    var elePanel = document.getElementById('short-cut-inner-panel');
    elePanel.style['display']='inline';
  }

  getNotificationData() {
    this.userService.getBlogs().subscribe((res:any) => {
      if(res && res.data) {
        this.notificationList = res.data;
        this.userService.setBlogsData(res.data)
      }
    })
  }


  closeNotificationSideBar() {
    this.toggleNotificationsSidePanel = false;
    // var ele = document.getElementById('short-cut-notify-panel');
    // ele.style['right']='0';

    var elePanel = document.getElementById('short-cut-notify-inner-panel');
    elePanel.style['display']='none';
  }

  NotificationSideBarClick() {
    this.getNotificationData();
    this.toggleNotificationsSidePanel = true;
    // var ele = document.getElementById('short-cut-notify-panel');
    // ele.style['right']='350px';
    var elePanel = document.getElementById('short-cut-notify-inner-panel');
    elePanel.style['display']='inline';
  }

  getOTP() {
    this.getOTPclicked = true;
    if(this.registerForm.controls.mobile.valid) {
      this.isverified = true;
      this.quizService.sentOtp(this.registerForm.value.mobile).subscribe((res: any) => {
        if(res && res.state == 200) {
          setTimeout(() => {
           // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
            this.verify_message = 'OTP has been sent to your mobile number';
            this.startTimer();
            this.otpFetched = true;
            setTimeout(() => {
              this.verify_message = '';
              this.isverified = false;
            }, 3000);
          }, 10);
        }
      });
    }
  }

  getLoginOTP() {
    this.getOTPclicked = true;
    if(this.mobileForm.controls.mobile.valid) {
      this.isverified = true;
      this.quizService.sentOtp(this.mobileForm.value.mobile).subscribe((res: any) => {
        if(res && res.state == 200) {
          setTimeout(() => {
           // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
            this.verify_message = 'OTP has been sent to your mobile number';
            this.startTimer();
            this.otpFetched = true;
            setTimeout(() => {
              this.verify_message = '';
              this.isverified = false;
            }, 3000);
          }, 10);
        }
      });
    }
  }


  startTimer() {
    var me = this;
    this.isFirstTime = false;
    this.dDay = new Date();
    this.dDay.setSeconds(this.dDay.getSeconds() + 31);
   var int  = setInterval(function() {
     if(!me.stopTimer) {
        me.getTimeDifference();
     } else {
       clearInterval(int);
       me.stopTimer = false;
       me.getOTPclicked = false;
     }
   }, 1000);

  }

  private getTimeDifference () {
    this.timeDifference = this.dDay.getTime() - new  Date().getTime();
    this.allocateTimeUnits(this.timeDifference);
}

private allocateTimeUnits (timeDifference) {
    this.secondsToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond) % this.SecondsInAMinute);
    this.minutesToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour) % this.SecondsInAMinute);
    this.hoursToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute) % this.hoursInADay);
    this.daysToDday = Math.floor((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
    if(this.secondsToDday <= 0) {
      this.stopTimer=true;
    }
}

verifyMobile() {
  this.regBtn = true;
  this.isverified = true;
  this.quizService.verifyOtp(this.registerForm.value['otp'],this.registerForm.value['mobile'],0 ).subscribe((res:any) => {
    if(res && res.state == 200) {
      if(res.data.otp_verify == 1) {
        this.regBtn=false;
        setTimeout(() => {
          // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
           this.verify_message = 'Mobile Number Verified Successfully';
           setTimeout(() => {
             this.verify_message = '';
             this.isverified = false;
           }, 3000);
         }, 10);
      } else {
        this.regBtn=true;
        setTimeout(() => {
          // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
           this.error_message = res.data.msg;
           setTimeout(() => {
             this.error_message = '';
             this.isverified = false;
           }, 3000);
         }, 10);
      }
    }
  });
}

verifyLoginMobile() {
  this.logBtn = true;
  this.isverified = true;
  this.quizService.verifyOtp(this.mobileForm.value['otp'],this.mobileForm.value['mobile'],0 ).subscribe((res:any) => {
    if(res && res.state == 200) {
      if(res.data.otp_verify == 1) {
        this.logBtn=false;
        setTimeout(() => {
          // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
          this.userDataByMobile(this.mobileForm.value['mobile']);
          this.verify_message = 'Please Wait....Logging in';
           setTimeout(() => {
             this.verify_message = '';
             this.isverified = false;
           }, 3000);
         }, 10);
      } else {
        this.logBtn=true;
        setTimeout(() => {
          // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
           this.error_message = res.data.msg;
           setTimeout(() => {
             this.error_message = '';
             this.isverified = false;
           }, 3000);
         }, 10);
      }
    }
  });
}

customLoginTabsChange(event) {
  this.getOTPclicked = false;
    this.otpFetched = false;
    this.secondsToDday =0;
    this.minutesToDday = 0;
    this.hoursToDday = 0;
    this.daysToDday = 0;
    this.isFirstTime = true;
  this.selectedLoginIndex = event;
} 


onLoginSubmit() {
  this.submitted = true;
  this.isEmailLoginClicked = true;
  if (this.loginForm.invalid) {
    setTimeout(() => {
      this.isEmailLoginClicked = false;
      this.submitted=false;
     }, 500);
    return;
  } else {
    this.logBtn = true;
   // this.loginForm.value.password = this.encPwdService.encryptUsingAES256(this.loginForm.value.password);
    $('#logBtn').html('please wait...');
    //console.log(this.registerForm.value); return false;
    this.userService.validateLogin(this.loginForm.value)
      .subscribe((response: any) => {
        if (response.state === 200) {
          //console.log(response.data);
          this.message = '<div class="alert alert-success">Loggedin Successfully.</div>';
          localStorage.setItem('userData', JSON.stringify(response.data));
          localStorage.setItem('utmData', '');
          let scholorTestId = localStorage.getItem('scholorTestId');
          if(scholorTestId) {
            this.registerClicked(response.data.user_id, scholorTestId, true);
          } else {
            // $('#unlock_course').modal('hide');
            // $('#subscribe_course').modal('hide');
            // $('#unlock_course_offer').modal('hide');
            if(localStorage.getItem('currUrl')){
              window.location.href = this.config.getConfig('ROOT_URL') +JSON.parse(localStorage.getItem('currUrl'));
             // window.location.href = this.quizService.rootUrl +JSON.parse(localStorage.getItem('currUrl'));
            }else{
              this.router.navigate(['/user/home']);
            //  window.location.reload();
            }
          }
        } else {
         setTimeout(() => {
          this.isEmailLoginClicked = false;
          this.submitted=false;
          this.logBtn=true;
         }, 500);
          this.message = '<div class="alert alert-danger">'+response.msg+' If you are facing trouble then please contact us at ' +  this.emailId + ' </div>';
        }

        this.logBtn = false;
        $('#logBtn').html('Login');
        this.isMsg = false;
    });
  }
}


/*prepareLoginButton() {
  this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
    (googleUser) => {

      let profile = googleUser.getBasicProfile();
      // console.log('Token || ' + googleUser.getAuthResponse().id_token);
      // console.log('ID: ' + profile.getId());
      // console.log('Name: ' + profile.getName());
      // console.log('Image URL: ' + profile.getImageUrl());
      // console.log('Email: ' + profile.getEmail());


      let userData = {
        'first_name': profile.getName(),
        'email': profile.getEmail(),
        'profile_pic': profile.getImageUrl(),
        'token_id': googleUser.getAuthResponse().id_token,
        'reg_type': 'google',
      };
      this.userService.userRegistration(userData).subscribe(
        (res:any) =>{
          if(res.state === 200){
            //console.log('Register Successfully. User id is:- ', res.data.user_id);
            localStorage.setItem('userData', JSON.stringify(res.data));
            location.reload();
          }else{
            //console.log(res.msg);
          }

        }
      );


    }, (error) => {
      //console.log(JSON.stringify(error, undefined, 2));
    });

    //this.router.navigate(['/user/home']);
}

googleSDK() {

  window['googleSDKLoaded'] = () => {
    window['gapi'].load('auth2', () => {
      this.auth2 = window['gapi'].auth2.init({
        client_id: '537795635068-1r7tjvhihp06f6shdsq93044shtcqdsm.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        scope: 'profile email'
      });
      //alert("loginCalled");
      this.prepareLoginButton();
    });
  }

  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'google-jssdk'));

}*/

getRegisterMobileNoExists() {
  this.getOTPclicked = true;
  this.userService.getMobileNoExists(this.registerForm.value.mobile).subscribe((res:any) => {
      if(res && res.state == 200) {
        this.error_message = res.msg;
        this.getOTPclicked = false;
        setTimeout(() => {
          this.error_message = '';
        }, 3000);
      } else if(res && res.state == 400) {
        this.getOTP();
      }
  })
}


getMobileNoExists() {
  this.getOTPclicked = true;
  this.userService.getMobileNoExists(this.mobileForm.value.mobile).subscribe((res:any) => {
      if(res && res.state == 200) {
        this.getLoginOTP();
      } else if(res && res.state == 400) {
        this.error_message = res.msg;
        this.getOTPclicked = false;
        setTimeout(() => {
          this.error_message = '';
        }, 3000);
      }
  })
}



// verifyMobile() {
// this.logBtn = true;
// this.isverified = true;
// this.quizService.verifyOtp(this.mobileForm.value['otp'],this.mobileForm.value['mobile'],0 ).subscribe((res:any) => {
//   if(res && res.state == 200) {
//     if(res.data.otp_verify == 1) {
//       this.logBtn=false;
//       setTimeout(() => {
//         // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
//         this.userDataByMobile(this.mobileForm.value['mobile']);
//         this.verify_message = 'Please Wait....Logging in';
//          setTimeout(() => {
//            this.verify_message = '';
//            this.isverified = false;
//          }, 3000);
//        }, 10);
//     } else {
//       this.logBtn=true;
//       setTimeout(() => {
//         // $('#user_sucess_msg').html('OTP has been sent to your mobile number');
//          this.error_message = res.data.msg;
//          setTimeout(() => {
//            this.error_message = '';
//            this.isverified = false;
//          }, 3000);
//        }, 10);
//     }
//   }
// });
// }

userDataByMobile(mobNo) {
this.userService.userDataByMobile(mobNo).subscribe((response:any) => {
  if (response.state === 200) {
    //console.log(response.data);
    this.message = '<div class="alert alert-success">Loggedin Successfully.</div>';
    localStorage.setItem('userData', JSON.stringify(response.data));
    localStorage.setItem('utmData', '');
    let scholorTestId = localStorage.getItem('scholorTestId');
    if(scholorTestId) {
      this.registerClicked(response.data.user_id, scholorTestId, true);
    } else {
      // $('#unlock_course').modal('hide');
      // $('#subscribe_course').modal('hide');
      // $('#unlock_course_offer').modal('hide');
      if(localStorage.getItem('currUrl')){
        window.location.href = this.config.getConfig('ROOT_URL') +JSON.parse(localStorage.getItem('currUrl'));
       // window.location.href = this.quizService.rootUrl +JSON.parse(localStorage.getItem('currUrl'));
      }else{
        this.router.navigate(['/user/home']);
      //  window.location.reload();
      }
    }
  } else {
    this.message = '<div class="alert alert-danger">'+response.msg+', If you are facing trouble then please contact us at ' +  this.emailId + ' </div>';
  }

  this.logBtn = false;
  $('#logBtn').html('Login');
  this.isMsg = false;
});
}

}
